import React from 'react';
import {
  audioMenuSectionStyle,
  audioMenuSectionTitleStyle,
  audioMenuDividerStyle,
  audioMenuTestButtonStyle,
} from '../../styles/deviceMenuStyles';
import DeviceMenuList from '../DeviceMenuList';

const AudioOptionsMenu = ({
  t,
  micDevices,
  activeMicDeviceId,
  onSelectMic,
  speakerDevices,
  activeSpeakerDeviceId,
  onSelectSpeaker,
  onTestSpeaker,
  menuStyle,
  getItemStyle,
}) => (
  <div
    style={menuStyle}
    role="menu"
    aria-label={t('VideoChatV2.audio.options')}
  >
    <div style={audioMenuSectionStyle}>
      <div style={audioMenuSectionTitleStyle}>{t('VideoChatV2.audio.microphone')}</div>
      <DeviceMenuList
        devices={micDevices}
        activeDeviceId={activeMicDeviceId}
        onSelect={onSelectMic}
        menuAriaLabel={t('VideoChatV2.audio.microphone')}
        menuStyle={{
          position: 'static',
          border: 'none',
          boxShadow: 'none',
          borderRadius: 0,
          padding: 0,
          gap: 4,
          background: 'transparent',
          minWidth: 0,
          width: '100%',
          maxWidth: '100%',
          overflow: 'visible',
        }}
        getItemStyle={getItemStyle}
      />
    </div>

    <div style={audioMenuDividerStyle} />

    <div style={audioMenuSectionStyle}>
      <div style={audioMenuSectionTitleStyle}>{t('VideoChatV2.audio.speaker')}</div>
      <DeviceMenuList
        devices={speakerDevices}
        activeDeviceId={activeSpeakerDeviceId}
        onSelect={onSelectSpeaker}
        menuAriaLabel={t('VideoChatV2.audio.speaker')}
        menuStyle={{
          position: 'static',
          border: 'none',
          boxShadow: 'none',
          borderRadius: 0,
          padding: 0,
          gap: 4,
          background: 'transparent',
          minWidth: 0,
          width: '100%',
          maxWidth: '100%',
          overflow: 'visible',
        }}
        getItemStyle={getItemStyle}
      />
    </div>

    <div style={audioMenuDividerStyle} />

    <button
      type="button"
      style={audioMenuTestButtonStyle}
      onClick={onTestSpeaker}
    >
      {t('VideoChatV2.audio.testSpeaker')}
    </button>
  </div>
);

export default React.memo(AudioOptionsMenu);